import GitHubIcon from '@mui/icons-material/GitHub'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import YoutubeIcon from '@mui/icons-material/YouTube'
import { ReactComponent as ExercismIcon } from './assets/exercism.svg';
import { about } from '../../portfolio'
import './About.css'

const About = () => {
  const { name, role, description1, description2, 
    description3, description4, resume, social } = about

  return (
    <div className='about center'>
      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name}</span>
        </h1>
      )}

      {role && <h2 className='about__role'>A {role}</h2>}
      <p className='about__desc'>{description1 && description1}</p>
      <p className='about__desc'>{description2 && description2}</p>
      <p className='about__desc'>{description3 && description3}</p>
      <p className='about__desc'>{description4 && description4}</p>

      <div className='about__contact center sm:justify-center'>

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                // open in a new tab
                rel='noopener noreferrer'
                target='_blank'
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                rel='noopener noreferrer'
                target='_blank'
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}

            {social.youtube && (
              <a
                href={social.youtube}
                rel='noopener noreferrer'
                target='_blank'
                aria-label='youtube'
                className='link link--icon'
              >
                <YoutubeIcon />
              </a>
            )}

            {social.exercism && (
              <a
                href={social.exercism}
                rel='noopener noreferrer'
                target='_blank'
                aria-label='exercism'
                className='link link--icon'
              >
                <ExercismIcon width="50" height="30" />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
